module.exports = __webpack_public_path__ + "img/3-3.6c1aa3b9.svg";